import { createAction, props } from '@ngrx/store';
import { Sunbed, SunbedForm, Zone } from '@shared-models';

const actionPrefix = '[SUNBEDS]';

export const sunbedPrereservationAction = createAction(
  `${actionPrefix} Sunbed PreReservation`,
  props<{ zone: Zone; formData: SunbedForm; zoneIndex: number }>(),
);

export const addSunbedToCartAction = createAction(
  `${actionPrefix} Add Sunbed To Cart`,
  props<{ sunbed: Sunbed }>(),
);

export const removeSunbedFromCartAction = createAction(
  `${actionPrefix} Remove Sunbed From Cart`,
  props<{ sunbed: Sunbed }>(),
);

export const showSunbedCartAction = createAction(
  `${actionPrefix} Show Sunbed Cart`,
  props<{ display: boolean }>(),
);

export const savePaymentMethodAction = createAction(
  `${actionPrefix} Save Payment Method`,
  props<{ method: string; cardType: string }>(),
);

export const saveBookingIdAction = createAction(
  `${actionPrefix} Save Booking ID`,
  props<{ bookingId: string }>(),
);

export const paymentFinishedAction = createAction(`${actionPrefix} Payment Finished`);

export const savePaymentInvoiceTypeAction = createAction(
  `${actionPrefix} Save Payment Invoice Type`,
  props<{ invoiceType: string }>(),
);

export const sunbedToBeDisabledAction = createAction(
  `${actionPrefix} Sunbeds To Be Disabled`,
  props<{ sunbeds: Sunbed[] }>(),
);

export const setEnabledReservationsAction = createAction(
  `${actionPrefix} Set Enabled Reservations`,
  props<{ enabled: boolean }>(),
);

export const emptyShoppingCartAction = createAction(
  `${actionPrefix} Empty Shopping Cart`,
);
